module.exports = __webpack_public_path__ + "static/sb1-0552abe7a76e0eb59b613fc3f76af4c7.jpg";